"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var util_1 = require("./util");
/**
 * Conditionally render components based on the truthy-ness of evaluating the `test` prop.
 * Render `then` if `test` evaluates to truthy, render `else` otherwise.
 */
function If(_a) {
    var test = _a.test, then = _a.then, _else = _a["else"];
    return util_1.toElement(test ? then : _else);
}
exports.If = If;
If.propTypes = {
    test: PropTypes.any,
    then: PropTypes.any.isRequired,
    else: PropTypes.any
};
//# sourceMappingURL=if.js.map